import React, { useState } from "react";
import { api } from "../../services/api";
import { useHistory } from "react-router-dom";
import {
  Button,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  CircularProgress
} from "@mui/material";
import { Close, Warning } from "@mui/icons-material";

export default function DeleteMemberModal(props) {
  const {
    isOpen,
    toggle,
    id,
    memberType,
    memberName,
    onSuccess,
    onError
  } = props;

  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const getTitleAndMessage = () => {
    switch (memberType) {
      case 'owner':
        return {
          title: 'Eliminar Owner',
          message: '¿Estás seguro de que quieres eliminar a este owner?',
          warningColor: '#FF5656'
        };
      case 'colaborador':
        return {
          title: 'Eliminar Colaborador',
          message: '¿Estás seguro de que quieres eliminar a este colaborador?',
          warningColor: '#FF5656'
        };
      case 'cliente':
        return {
          title: 'Eliminar Cliente',
          message: '¿Estás seguro de que quieres eliminar a este cliente?',
          warningColor: '#FF5656'
        };
      case 'expositor':
        return {
          title: 'Eliminar Expositor',
          message: '¿Estás seguro de que quieres eliminar a este expositor?',
          warningColor: '#FF5656'
        };
      case 'vendedor':
        return {
          title: 'Eliminar Vendedor',
          message: '¿Estás seguro de que quieres eliminar a este vendedor?',
          warningColor: '#FF5656'
        };
      case 'tesorero':
        return {
          title: 'Eliminar Tesorero',
          message: '¿Estás seguro de que quieres eliminar a este tesorero?',
          warningColor: '#FF5656'
        };
      default:
        return {
          title: 'Eliminar Miembro',
          message: '¿Estás seguro de que quieres eliminar a este miembro?',
          warningColor: '#FF5656'
        };
    }
  };

  const { title, message, warningColor } = getTitleAndMessage();

  async function handleDelete() {
    setLoading(true);
    try {
      const response = await api.participaciones.deleteParticipacion(id);

      if (response.status === "success") {
        if (onSuccess) {
          onSuccess();
        } else {
          history.go(0);
        }
      } else {
        if (onError) {
          onError(response.message);
        }
      }
    } catch (error) {
      if (onError) {
        onError(error.message);
      }
    } finally {
      setLoading(false);
      toggle();
    }
  }

  return (
    <Dialog
      open={isOpen}
      onClose={!loading ? toggle : undefined}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '8px',
        }
      }}
    >
      <DialogTitle sx={{
        fontFamily: 'Bricolage Grotesque',
        color: '#0B0060',
        borderBottom: '1px solid #eaeaea',
        pb: 2,
        pr: 6
      }}>
        <Box display="flex" alignItems="center">
          <Warning sx={{ color: warningColor, marginRight: 1.5 }} />
          <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
        <IconButton
          aria-label="close"
          onClick={toggle}
          disabled={loading}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ mt: 2, pt: 3, pb: 2, px: 3 }}>
        <DialogContentText sx={{
          fontFamily: 'Bricolage Grotesque',
          color: '#333',
          mb: 1
        }}>
          {message}
          {memberName && <strong> {memberName}</strong>}
        </DialogContentText>

        <DialogContentText sx={{
          fontFamily: 'Bricolage Grotesque',
          color: '#666',
          fontSize: '0.9rem'
        }}>
          Esta acción no se puede deshacer.
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={toggle}
          disabled={loading}
          sx={{
            fontFamily: 'Bricolage Grotesque',
            color: '#5656ff',
            '&:hover': {
              backgroundColor: '#f0f0ff'
            },
            textTransform: 'none'
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={handleDelete}
          disabled={loading}
          variant="contained"
          sx={{
            fontFamily: 'Bricolage Grotesque',
            backgroundColor: '#FF5656',
            '&:hover': {
              backgroundColor: '#ff3333'
            },
            '&.Mui-disabled': {
              backgroundColor: '#ffaaaa',
              color: 'white'
            },
            textTransform: 'none'
          }}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : null}
        >
          {loading ? 'Eliminando...' : 'Eliminar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}